module.exports = __webpack_public_path__ + "img/img.1f0ef281.png";